import { AWSError } from 'aws-sdk';
import { Errors } from './errors';
import { ErrorMessage } from './error-message';
import { LogService } from '../services/log.service';

export class ErrorHandler {
  private map: Map<string, ErrorMessage>;
  private genericMessage = new ErrorMessage(Errors.GENERIC.message);

  constructor(private log: LogService) {
    this.map = new Map<string, ErrorMessage>();
    this.add(Errors.LIMIT_EXCEEDED);
  }

  add(err: AWSError, msg?: ErrorMessage) {
    if (!msg) {
      msg = new ErrorMessage(err.message);
    }
    this.map.set(err.code, msg);
  }

  get(err: AWSError): string {
    let msg = this.map.get(err.code);
    if (!msg) {
      msg = this.genericMessage;
    }
    return msg.get(err);
  }

  setGenericMessage(msg: string) {
    this.genericMessage = new ErrorMessage(msg);
  }
}
